import React from 'react';
import PortalFrame from '../ui/portal-frame.js';
import { Typography } from '@mui/material';
//import { useCurrentUserProfile } from "../../api/swrcurrentuserprofile.js";

//step 1 - import
import { useContext } from 'react';
import UserProfileContext from '../ui/userprofilecontext.js';
import PageSkeleton from '../ui/pageskeleton.js';
//import SampleDRFAReport from '../ui/report-drfa-sample.js';
import UnmatchedTransfersReport from '../ui/report-unmatched-transfers.js';
//import { useDRFAReportForCurrentCase } from '../../api/swrdrfareportforcurrentcase.js';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min.js';
import ReportContext from '../ui/user-report-context.js';

export default function UnmatchedTransfersReportPage(props) {
    //Step 2 added new way
    const userProfileContext = useContext(UserProfileContext);

    //const userProfile = useCurrentUserProfile(); // comment out old way

    //const userProfile = userProfileContext.userProfile  // add new way
    //const orgID = userProfileContext.isLoading ? null : userProfileContext.userProfile.currentOrg.orgID
    //const caseID = userProfileContext.isLoading ? null : userProfileContext.userProfile.currentCase.caseID
    
    const title = "Unmatched Transfers Report"
    const reportID = useParams().reportID
    const reportContext = useContext(ReportContext);

    
    const report=reportContext.getReportByID(reportID)

    if (reportContext.isLoading ) {


        return (
            <PortalFrame title={title}>
                <PageSkeleton />
            </PortalFrame>
        )
    }
    //console.log(`in UnmatchedTransfersReportPage ${JSON.stringify(report)}`)
    //console.log(`report ${JSON.stringify(report)}`)

    return (
        <PortalFrame title={title}>

        <UnmatchedTransfersReport reportID={reportID} reportData={report.reportData}/>
        
        </PortalFrame>
    );
}